module.exports = __webpack_public_path__ + "img/qr-slide-bg2.c25caa7d.png";